export default "__VITE_ASSET__C26iO$KR__"